import actions from "./actions";

/* eslint import/no-anonymous-default-export: [2, {"allowObject": true}] */
export default {
  manualRehydrateMap: actions.manualRehydrateMap,
  setExtent: actions.setExtent,
  mapLoaded: actions.mapLoaded,
  setAddIrwinIdToPerimeter: actions.setAddIrwinIdToPerimeter
};
